var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgCheckMarkColored = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  viewBox: "0 0 32 32",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#svg-1283572571__a)",
  d: "M15.435 3.547a.81.81 0 0 1 1.13 0l2.363 2.286c.18.174.43.255.679.22l3.256-.46a.81.81 0 0 1 .914.664l.568 3.239c.044.247.198.46.42.577l2.904 1.541c.387.206.542.681.35 1.075l-1.445 2.954a.81.81 0 0 0 0 .714l1.444 2.954a.81.81 0 0 1-.349 1.075l-2.904 1.54a.81.81 0 0 0-.42.578l-.568 3.239a.81.81 0 0 1-.914.664l-3.256-.46a.81.81 0 0 0-.679.22l-2.363 2.286a.81.81 0 0 1-1.13 0l-2.363-2.286a.81.81 0 0 0-.679-.22l-3.256.46a.81.81 0 0 1-.914-.664l-.568-3.239a.81.81 0 0 0-.42-.577l-2.904-1.541a.81.81 0 0 1-.35-1.075l1.445-2.954a.81.81 0 0 0 0-.714L3.98 12.69a.81.81 0 0 1 .35-1.075l2.904-1.54a.81.81 0 0 0 .42-.578l.568-3.239a.81.81 0 0 1 .914-.664l3.256.46a.81.81 0 0 0 .679-.22z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.99,
  d: "m12.419 15.847 2.762 2.793 4.42-5.027"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "svg-1283572571__a",
  x1: 3,
  x2: 25.706,
  y1: 3,
  y2: 31.614,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF465D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F711BA"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckMarkColored);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };